import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    GigCards,
    ListView
} from '@fiverr/gig_card';
import GigImpressionable from './GigImpressionable';
import ViewAllLink from './ViewAllLink';
import '@fiverr/gig_card/dist/index.css';
import './style.scss';

export default class Gigs extends Component {
    constructor(props) {
        super(props);

        const {
            name,
            categoryCachedSlug,
            subCategoryCachedSlug
        } = props;

        this.carouselTitle = i18n.t('pro_homepage.sections.gigs.title', { name });
        this.subCategoryPath = i18n.t('pro_homepage.sections.sub_category_path', { categoryCachedSlug, subCategoryCachedSlug });
    }

    componentDidMount() {
        this.createImpressionable();
    }

    createImpressionable() {
        const { gigs } = this.props;

        if (!gigs || !gigs.length) { return; }

        const {
            viewObject,
            requestContext,
            carouselPosition,
            categoryId,
            subCategoryId
        } = this.props;

        const pageCtxId = viewObject.page_ctx_id;
        const currentUser = requestContext.current_user;

        const enrichData = {
            carouselPosition,
            pageCtxId,
            currentUser,
            categoryId,
            subCategoryId,
            carouselTitle: this.carouselTitle,
            sourcepage: 'pro_homepage',
            isPro: true
        };

        new GigImpressionable({
            container: document.querySelector(`.gigs-wrapper.no-${subCategoryId}`),
            data: gigs
        }, enrichData);
    }

    render() {
        const {
            categoryId,
            subCategoryId,
            gigs = null,
            name,
            requestContext,
            viewObject,
            categoryCachedSlug,
            subCategoryCachedSlug,
            carouselPosition
        } = this.props;

        if (!gigs || !gigs.length) { return null; }

        const pageCtxId = viewObject.page_ctx_id;

        const context = {
            pageCtxId,
            abTests: {
                PRO_EXPERIENCE: 2
            }
        };

        const showListView = requestContext.is_mobile;
        const linkTitle = i18n.t('pro_homepage.sections.gigs.link_title', { name });

        return (
            <section className={`gigs-wrapper no-${subCategoryId}`}
                data-impression-id={subCategoryId}>
                <header>
                    <h2>{this.carouselTitle}</h2>
                    <ViewAllLink desktop
                        href={this.subCategoryPath}
                        text={linkTitle}
                        categoryId={categoryId}
                        categoryName={categoryCachedSlug}
                        subCategoryId={subCategoryId}
                        subCategoryName={subCategoryCachedSlug}
                        title={this.carouselTitle}
                        position={carouselPosition}
                        pageCtxId={pageCtxId}/>
                </header>

                {!showListView &&
                    <GigCards cardSize="medium"
                        gigs={gigs}
                        user={requestContext.current_user}
                        context={context}
                        shouldEnrichData/>}

                {showListView &&
                    <ListView isMobile="true"
                        gigs={gigs}
                        user={requestContext.current_user}
                        context={context}
                        shouldEnrichData/>}

                <ViewAllLink mobile
                    href={this.subCategoryPath}
                    text={linkTitle}
                    categoryId={categoryId}
                    categoryName={categoryCachedSlug}
                    subCategoryId={subCategoryId}
                    subCategoryName={subCategoryCachedSlug}
                    title={this.carouselTitle}
                    position={carouselPosition}
                    pageCtxId={pageCtxId}/>
            </section>
        );
    }
}

Gigs.propTypes = {
    categoryId: PropTypes.number,
    subCategoryId: PropTypes.number,
    categoryCachedSlug: PropTypes.string,
    subCategoryCachedSlug: PropTypes.string,
    gigs: PropTypes.array,
    name: PropTypes.string,
    carouselPosition: PropTypes.number,
    requestContext: PropTypes.object,
    viewObject: PropTypes.object
};

Gigs.defaultProps = {
    categoryId: 0,
    subCategoryId: 0,
    categoryCachedSlug: '',
    subCategoryCachedSlug: '',
    gigs: [],
    name: '',
    carouselPosition: 0,
    requestContext: {},
    viewObject: {}
};



// WEBPACK FOOTER //
// ./src/common/HomePage/Gigs/index.js